export default class ReCaptcha {
    constructor(selector, captcha) {
        this.selector = selector;
        this.captcha = captcha;
        this.captchaId = null;
        this.siteKey = null;
    }

    render(callback) {
        if (!this.siteKey) {
            console.error('cannot render captcha, siteKey not found');
            return;
        }

        let config = { sitekey: this.siteKey };

        if (callback) {
            config['callback'] = callback;
        }

        this.captchaId = this.captcha.render(this.elem, config);
    }

    reset() {
        if (!this.rendered()) {
            console.error('cannot reset captcha, captcha not rendered');
            return;
        }

        this.captcha.reset(this.captchaId);
    }

    rendered() {
        return Number.isInteger(this.captchaId);
    }

    exists() {
        if (!this.elem) {
            return false;
        }

        return this.elem.firstElementChild && this.rendered();
    }

    completed() {
        if (!this.rendered()) {
            return false;
        }

        return this.captcha.getResponse(this.captchaId);
    }

    set key(key) {
        this.siteKey = key;
    }

    get key() {
        return this.siteKey;
    }

    get elem() {
        let elem = document.querySelector(this.selector);

        if (!elem) {
            console.error(`element ${this.selector} not exists`);
        }

        return elem;
    }
}



// WEBPACK FOOTER //
// ./blocks/google-captcha.js